<template>
    <div :class="{'has-error': invalid||!!error}" class="form-group has-icon-left">
        <div class="input-group">
            <open-icon glyph="calendar" class="form-icon"></open-icon>
            <input type="text" :value="field_value" :placeholder="placeholder" :disabled="!editable" @focus="autoselect_action" @blur="standardize" class="form-input" />
            <slot name="right_addon"></slot>
        </div>
        <p v-if="!!error" class="form-input-hint">{{ error }}</p>
    </div>
</template>

<script type="text/javascript">
import OpenIcon from "../../nibnut/components/OpenIcon"

import natural_date_field_mixin from "./natural_date_field_mixin"

const chrono = require("chrono-node")

export default {
    name: "NaturalDateField",
    mixins: [natural_date_field_mixin],
    mounted () {
        this.sync()
    },
    watch: {
        value: "sync"
    },
    components: {
        OpenIcon
    },
    methods: {
        update (date_value, emit) {
            let date = chrono.parseDate(date_value ? date_value.replace(/\s*@\s*/, " ") : date_value)
            if(!date) {
                if(!date_value) date = ""
                else date = null
            } else {
                date = this.$moment(date)
                if(!date) date = ""
                else if(!this.valid_date(date)) date = null
                else date = date.format(this.dateFilter)
            }

            if(date !== null) {
                this.invalid = false
                this.field_value = date // optimistic update
                if(emit) this.$emit("input", date)
            } else {
                this.invalid = true
                this.field_value = date_value
            }
        },
        sync () {
            this.update(this.value)
        },
        valid_date (date) {
            if(date && (date.format("YYYY-MM-DD") === "9999-12-31")) return true
            const min = this.$moment().subtract(((this.min !== null) ? this.min : 182500), "days")
            const max = this.$moment().add(((this.max !== null) ? this.max : 182500), "days")
            return date.isSameOrAfter(min) && date.isSameOrBefore(max)
        },
        autoselect_action (event) {
            event.target.select()
        },
        standardize (event) {
            this.update(event.target.value, true)
        }
    },
    props: {
        error: {
            validator: prop => {
                return (typeof prop === "string") || (prop === null)
            }
        }
    },
    data () {
        return {
            invalid: false,
            field_value: null
        }
    }
}
</script>
